/**
 * Vanilla JavaScript replacement of $.isNumeric()
 * @param value : value to check
 */
export default function isNumeric(value: unknown): value is number {
  return !Number.isNaN(parseFloat(value as string)) && Number.isFinite(value);
}
